/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

import { gql } from "@apollo/client";
import PromiseQuery from "../../../Basis/Queries/PromiseQuery";
import { nameof } from "../../../Basis/Utils/AnyUtil";
import Adressart from "../../../Shared/DomainDrivenDesign/Commands/Adressart";

export interface KontoAdresse {
    kontoAdressId: string;
    kontoId: string;
    adressart: Adressart;
    name1?: string;
    name2?: string;
    name3?: string;
    matchcode: string;
    titel?: string;
    anrede?: string;
    geschlecht?: string;
    vorname?: string;
    nachname?: string;
    strasse?: string;
    postleitzahl?: string;
    ort?: string;
    region?: string;
    land?: string;
    briefanrede?: string;
    eMail: string;
    mobil?: string;
    telefon?: string;
    fax?: string;
    homepage?: string;
    geburtsdatum?: string;
    hatRechnungsadresse: boolean;
    rechnungsadresseAdressart?: Adressart;
    rechnungsadresseName1?: string;
    rechnungsadresseName2?: string;
    rechnungsadresseName3?: string;
    rechnungsadresseAnrede?: string;
    rechnungsadresseGeschlecht?: string;
    rechnungsadresseTitel?: string;
    rechnungsadresseVorname?: string;
    rechnungsadresseNachname?: string;
    rechnungsadresseStrasse?: string;
    rechnungsadressePostleitzahl?: string;
    rechnungsadresseOrt?: string;
    rechnungsadresseRegion?: string;
    rechnungsadresseLand?: string;
    rechnungsadresseBriefanrede?: string;
    rechnungsadresseEMail?: string;
    rechnungsadresseMobil?: string;
    rechnungsadresseTelefon?: string;
    rechnungsadresseFax?: string;
    rechnungsadresseHomepage?: string;
    rechnungsadresseGeburtsdatum?: string;
    istHauptadresse: boolean;
}

export interface Konto {
    kontoId: string;
    eMail: string;
    kontoAdressen: KontoAdresse[];
}

const QUERY_NAME = "Mandanten_LadeEigenesKonto";
const QUERY = gql`
    query ${QUERY_NAME} {
        ${QUERY_NAME} {
            ${nameof<Konto>("kontoId")}
            ${nameof<Konto>("eMail")}
            ${nameof<Konto>("kontoAdressen")} {
                ${nameof<KontoAdresse>("kontoAdressId")}
                ${nameof<KontoAdresse>("kontoId")}
                ${nameof<KontoAdresse>("adressart")}
                ${nameof<KontoAdresse>("matchcode")}
                ${nameof<KontoAdresse>("name1")}
                ${nameof<KontoAdresse>("name2")}
                ${nameof<KontoAdresse>("name3")}
                ${nameof<KontoAdresse>("anrede")}
                ${nameof<KontoAdresse>("geschlecht")}
                ${nameof<KontoAdresse>("titel")}
                ${nameof<KontoAdresse>("vorname")}
                ${nameof<KontoAdresse>("nachname")}
                ${nameof<KontoAdresse>("strasse")}
                ${nameof<KontoAdresse>("postleitzahl")}
                ${nameof<KontoAdresse>("ort")}
                ${nameof<KontoAdresse>("region")}
                ${nameof<KontoAdresse>("land")}
                ${nameof<KontoAdresse>("briefanrede")}
                ${nameof<KontoAdresse>("eMail")}
                ${nameof<KontoAdresse>("mobil")}
                ${nameof<KontoAdresse>("telefon")}
                ${nameof<KontoAdresse>("fax")}
                ${nameof<KontoAdresse>("homepage")}
                ${nameof<KontoAdresse>("geburtsdatum")}
                ${nameof<KontoAdresse>("hatRechnungsadresse")}
                ${nameof<KontoAdresse>("rechnungsadresseAdressart")}
                ${nameof<KontoAdresse>("rechnungsadresseName1")}
                ${nameof<KontoAdresse>("rechnungsadresseName2")}
                ${nameof<KontoAdresse>("rechnungsadresseName3")}
                ${nameof<KontoAdresse>("rechnungsadresseAnrede")}
                ${nameof<KontoAdresse>("rechnungsadresseGeschlecht")}
                ${nameof<KontoAdresse>("rechnungsadresseTitel")}
                ${nameof<KontoAdresse>("rechnungsadresseVorname")}
                ${nameof<KontoAdresse>("rechnungsadresseNachname")}
                ${nameof<KontoAdresse>("rechnungsadresseStrasse")}
                ${nameof<KontoAdresse>("rechnungsadressePostleitzahl")}
                ${nameof<KontoAdresse>("rechnungsadresseOrt")}
                ${nameof<KontoAdresse>("rechnungsadresseRegion")}
                ${nameof<KontoAdresse>("rechnungsadresseLand")}
                ${nameof<KontoAdresse>("rechnungsadresseBriefanrede")}
                ${nameof<KontoAdresse>("rechnungsadresseEMail")}
                ${nameof<KontoAdresse>("rechnungsadresseMobil")}
                ${nameof<KontoAdresse>("rechnungsadresseTelefon")}
                ${nameof<KontoAdresse>("rechnungsadresseFax")}
                ${nameof<KontoAdresse>("rechnungsadresseHomepage")}
                ${nameof<KontoAdresse>("rechnungsadresseGeburtsdatum")}
                ${nameof<KontoAdresse>("istHauptadresse")}
            }
        }
    }
`;

export class PromiseLadeEigenesKonto extends PromiseQuery<Konto, void> {
    public static readonly queryName: string = QUERY_NAME;

    public constructor() {
        super(QUERY);
    }

    public get name(): string {
        return PromiseLadeEigenesKonto.queryName;
    }
}
